import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'onefaceui-react-components';
import { checkPermissions, getResourceTo } from 'react/utils/utils';

function AccordionTimeWindow({ locationId }) {
  const openEditStop = () => {
    const url = `#/Location/${locationId}/LocationOverrideTimeWindow`;
    App.Objects.LocationOverrideTimeWindow.setParentId(locationId);
    window.location.href = url;
  };

  const overrideTimeWindowPermissions = [
    'LOCATIONOVERRIDETIMEWINDOW_CREATE',
    'LOCATIONOVERRIDETIMEWINDOW_UPDATE',
    'LOCATIONOVERRIDETIMEWINDOW_LIST',
    'LOCATIONOVERRIDETIMEWINDOW_DELETE'
  ];

  const hasOverrideTimeWindowPermissions = overrideTimeWindowPermissions
    .every((permission) => checkPermissions(permission));

  if (!hasOverrideTimeWindowPermissions) {
    return (
      <p className="noTimeWindow">
        {getResourceTo('Stop.popup.tw.noRegisteredLocation')}
      </p>
    );
  }

  return (
    <Text size="xs" className="noTimeWindow">
      {getResourceTo('Stop.popup.tw.noRegistered')}
      {' '}
      <button
        type="button"
        className="noTimeWindowLink"
        onClick={openEditStop}
        tabIndex={0}
      >
        {getResourceTo('Stop.popup.tw.noRegisteredLink')}
      </button>
    </Text>
  );
}

AccordionTimeWindow.propTypes = {
  locationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default AccordionTimeWindow;
